const countriesCoordsDict = {
  EU_MLT: {
     lat: 35.8333,
     lng: 14.5833
  },
  EU_AND: {
     lat: 42.5,
     lng: 1.6
  },
  NA_ATG: {
     lat: 17.05,
     lng: -61.8
  },
  NA_BRB: {
     lat: 13.1667,
     lng: -59.5333
  },
  NA_DMA: {
     lat: 15.4167,
     lng: -61.3333
  },
  NA_GRD: {
     lat: 12.1167,
     lng: -61.6667
  },
  EU_LI: {
     lng: 9.596195846,
     lat: 47.095570401
  },
  NA_KNA: {
     lat: 17.3333,
     lng: -62.75
  },
  NA_VTC: {
     lng: -61.163367718,
     lat: 12.866081478
  },
  NA_LCA: {
     lat: 13.8833,
     lng: -61.1333
  },
  AS_BHR: {
     lat: 26,
     lng: 50.55
  },
  AS_BRN: {
     lat: 4.5,
     lng: 114.6667
  },
  AS_MDV: {
     lat: 3.25,
     lng: 73
  },
  AS_SGP: {
     lat: 1.3667,
     lng: 103.8
  },
  AF_CPV: {
     lat: 16,
     lng: -24
  },
  AF_COM: {
     lat: -12.1667,
     lng: 44.25
  },
  AF_MUS: {
     lat: -20.2833,
     lng: 57.55
  },
  AF_STP: {
     lat: 1,
     lng: 7
  },
  AF_SYC: {
     lat: -4.5833,
     lng: 55.6667
  },
  OC_KIR: {
     lat: 1.4167,
     lng: 173
  },
  OC_MHL: {
     lat: 9,
     lng: 168
  },
  OC_FSM: {
     lat: 6.9167,
     lng: 158.25
  },
  OC_NRU: {
     lat: -0.5333,
     lng: 166.9167
  },
  OC_PLW: {
     lat: 7.5,
     lng: 134.5
  },
  OC_SLB: {
     lat: -8,
     lng: 159
  },
  OC_WSM: {
     lat: -13.5833,
     lng: -172.3333
  },
  EU_SMR: {
     lat: 43.7667,
     lng: 12.4167
  },
  EU_MCO: {
     lat: 43.7333,
     lng: 7.4
  },
  EU_VAT: {
     lat: 41.9,
     lng: 12.45
  },
  AS_LBN: {
     lat: 33.8333,
     lng: 35.8333
  },
  NA_BHS: {
     lat: 24.25,
     lng: -76
  },
  NA_BLZ: {
     lat: 17.25,
     lng: -88.75
  },
  NA_CAN: {
     lat: 60,
     lng: -95
  },
  NA_CRI: {
     lat: 10,
     lng: -84
  },
  NA_CUB: {
     lat: 21.5,
     lng: -80
  },
  NA_DOM: {
     lat: 19,
     lng: -70.6667
  },
  NA_GRL: {
     lat: 72,
     lng: -40
  },
  NA_GTM: {
     lat: 15.5,
     lng: -90.25
  },
  NA_HND: {
     lat: 15,
     lng: -86.5
  },
  NA_HTI: {
     lat: 19,
     lng: -72.4167
  },
  NA_JAM: {
     lat: 18.25,
     lng: -77.5
  },
  NA_MEX: {
     lat: 23,
     lng: -102
  },
  NA_NIC: {
     lat: 13,
     lng: -85
  },
  NA_PRI: {
     lat: 18.25,
     lng: -66.5
  },
  NA_PAN: {
     lat: 9,
     lng: -80
  },
  NA_SLV: {
     lat: 13.8333,
     lng: -88.9167
  },
  NA_USA: {
     lat: 38,
     lng: -97
  },
  NA_TTO: {
     lat: 11,
     lng: -61
  },
  SA_ARG: {
     lat: -34,
     lng: -64
  },
  SA_BRA: {
     lat: -10,
     lng: -55
  },
  SA_BOL: {
     lat: -17,
     lng: -65
  },
  SA_CHL: {
     lat: -30,
     lng: -71
  },
  SA_COL: {
     lat: 4,
     lng: -72
  },
  SA_ECU: {
     lat: -2,
     lng: -77.5
  },
  SA_FLK: {
     lat: -51.75,
     lng: -59
  },
  SA_GUY: {
     lat: 5,
     lng: -59
  },
  SA_PER: {
     lat: -10,
     lng: -76
  },
  SA_PRY: {
     lat: -23,
     lng: -58
  },
  SA_SUR: {
     lat: 4,
     lng: -56
  },
  SA_URY: {
     lat: -33,
     lng: -56
  },
  SA_VEN: {
     lat: 8,
     lng: -66
  },
  AS_AFG: {
     lat: 33,
     lng: 65
  },
  AS_ARE: {
     lat: 24,
     lng: 54
  },
  AS_ARM: {
     lat: 40,
     lng: 45
  },
  AS_AZE: {
     lat: 40.5,
     lng: 47.5
  },
  AS_BGD: {
     lat: 24,
     lng: 90
  },
  AS_BTN: {
     lat: 27.5,
     lng: 90.5
  },
  AS_CHN: {
     lat: 35,
     lng: 105
  },
  AS_CYN: {
     lng: 32.73178022637745,
     lat: 35.14002594658844
  },
  AS_CYP: {
     lat: 35,
     lng: 33
  },
  AS_GEO: {
     lat: 42,
     lng: 43.5
  },
  AS_IDN: {
     lat: -5,
     lng: 120
  },
  AS_IND: {
     lat: 20,
     lng: 77
  },
  AS_IRN: {
     lat: 32,
     lng: 53
  },
  AS_IRQ: {
     lat: 33,
     lng: 44
  },
  AS_ISR: {
     lat: 31.5,
     lng: 34.75
  },
  AS_JOR: {
     lat: 31,
     lng: 36
  },
  AS_JPN: {
     lat: 36,
     lng: 138
  },
  AS_KAZ: {
     lat: 48,
     lng: 68
  },
  AS_KGZ: {
     lat: 41,
     lng: 75
  },
  AS_KHM: {
     lat: 13,
     lng: 105
  },
  AS_KOR: {
     lat: 37,
     lng: 127.5
  },
  AS_KWT: {
     lat: 29.3375,
     lng: 47.6581
  },
  AS_LAO: {
     lat: 18,
     lng: 105
  },
  AS_LKA: {
     lat: 7,
     lng: 81
  },
  AS_MNG: {
     lat: 46,
     lng: 105
  },
  AS_MYS: {
     lat: 2.5,
     lng: 112.5
  },
  AS_MMR: {
     lat: 22,
     lng: 98
  },
  AS_NPL: {
     lat: 28,
     lng: 84
  },
  AS_OMN: {
     lat: 21,
     lng: 57
  },
  AS_PAK: {
     lat: 30,
     lng: 70
  },
  AS_PHL: {
     lat: 13,
     lng: 122
  },
  AS_PRK: {
     lat: 40,
     lng: 127
  },
  AS_PSX: {
     lng: 35.54566531753454,
     lat: 32.393992011030576
  },
  AS_QAT: {
     lat: 25.5,
     lng: 51.25
  },
  AS_SAU: {
     lat: 25,
     lng: 45
  },
  AS_SYR: {
     lat: 35,
     lng: 38
  },
  AS_THA: {
     lat: 15,
     lng: 100
  },
  AS_TJK: {
     lat: 39,
     lng: 71
  },
  AS_TKM: {
     lat: 40,
     lng: 60
  },
  AS_TLS: {
     lat: -8.55,
     lng: 125.5167
  },
  AS_TUR: {
     lat: 39,
     lng: 35
  },
  AS_TWN: {
     lat: 23.5,
     lng: 121
  },
  AS_UZB: {
     lat: 41,
     lng: 64
  },
  AS_VNM: {
     lat: 16,
     lng: 106
  },
  AS_YEM: {
     lat: 15,
     lng: 48
  },
  AF_AGO: {
     lat: -12.5,
     lng: 18.5
  },
  AF_BDI: {
     lat: -3.5,
     lng: 30
  },
  AF_BEN: {
     lat: 9.5,
     lng: 2.25
  },
  AF_BFA: {
     lat: 13,
     lng: -2
  },
  AF_BWA: {
     lat: -22,
     lng: 24
  },
  AF_CAF: {
     lat: 7,
     lng: 21
  },
  AF_CIV: {
     lat: 8,
     lng: -5
  },
  AF_CMR: {
     lat: 6,
     lng: 12
  },
  AF_COD: {
     lat: 0,
     lng: 25
  },
  AF_COG: {
     lat: -1,
     lng: 15
  },
  AF_EGY: {
     lat: 27,
     lng: 30
  },
  AF_ERI: {
     lat: 15,
     lng: 39
  },
  AF_ETH: {
     lat: 8,
     lng: 38
  },
  AF_GAB: {
     lat: -1,
     lng: 11.75
  },
  AF_DJI: {
     lat: 11.5,
     lng: 43
  },
  AF_DZA: {
     lat: 28,
     lng: 3
  },
  AF_GHA: {
     lat: 8,
     lng: -2
  },
  AF_GIN: {
     lat: 11,
     lng: -10
  },
  AF_GMB: {
     lat: 13.4667,
     lng: -16.5667
  },
  AF_KEN: {
     lat: 1,
     lng: 38
  },
  AF_GNB: {
     lat: 12,
     lng: -15
  },
  AF_GNQ: {
     lat: 2,
     lng: 10
  },
  AF_LBR: {
     lat: 6.5,
     lng: -9.5
  },
  AF_LBY: {
     lat: 25,
     lng: 17
  },
  AF_LSO: {
     lat: -29.5,
     lng: 28.5
  },
  AF_MAR: {
     lat: 32,
     lng: -5
  },
  AF_MDG: {
     lat: -20,
     lng: 47
  },
  AF_MLI: {
     lat: 17,
     lng: -4
  },
  AF_MOZ: {
     lat: -18.25,
     lng: 35
  },
  AF_NAM: {
     lat: -22,
     lng: 17
  },
  AF_MRT: {
     lat: 20,
     lng: -12
  },
  AF_MWI: {
     lat: -13.5,
     lng: 34
  },
  AF_RWA: {
     lat: -2,
     lng: 30
  },
  AF_SAH: {
     lng: -8.794883999049077,
     lat: 27.120696316022503
  },
  AF_SDN: {
     lat: 15,
     lng: 30
  },
  AF_NGA: {
     lat: 10,
     lng: 8
  },
  AF_NER: {
     lat: 16,
     lng: 8
  },
  AF_SDS: {
     lng: 33.963392794971185,
     lat: 9.464285229420625
  },
  AF_SEN: {
     lat: 14,
     lng: -14
  },
  AF_SLE: {
     lat: 8.5,
     lng: -11.5
  },
  AF_SOL: {
     lng: 48.938129510296505,
     lat: 9.451748968946674
  },
  AF_SOM: {
     lat: 10,
     lng: 49
  },
  AF_TCD: {
     lat: 15,
     lng: 19
  },
  AF_SWZ: {
     lat: -26.5,
     lng: 31.5
  },
  AF_TGO: {
     lat: 8,
     lng: 1.1667
  },
  AF_TUN: {
     lat: 34,
     lng: 9
  },
  AF_TZA: {
     lat: -6,
     lng: 35
  },
  AF_UGA: {
     lat: 1,
     lng: 32
  },
  AF_ZWE: {
     lat: -20,
     lng: 30
  },
  OC_AUS: {
     lat: -27,
     lng: 133
  },
  OC_FJI: {
     lat: -18,
     lng: 175
  },
  AF_ZAF: {
     lat: -29,
     lng: 24
  },
  AF_ZMB: {
     lat: -15,
     lng: 30
  },
  OC_NCL: {
     lat: -21.5,
     lng: 165.5
  },
  OC_NZL: {
     lat: -41,
     lng: 174
  },
  OC_PNG: {
     lat: -6,
     lng: 147
  },
  OC_VUT: {
     lat: -16,
     lng: 167
  },
  EU_ALB: {
     lat: 41,
     lng: 20
  },
  EU_AUT: {
     lat: 47.3333,
     lng: 13.3333
  },
  EU_BEL: {
     lat: 50.8333,
     lng: 4
  },
  EU_BGR: {
     lat: 43,
     lng: 25
  },
  EU_BIH: {
     lat: 44,
     lng: 18
  },
  EU_BLR: {
     lat: 53,
     lng: 28
  },
  EU_CHE: {
     lat: 47,
     lng: 8
  },
  EU_CZE: {
     lat: 49.75,
     lng: 15.5
  },
  EU_DEU: {
     lat: 51,
     lng: 9
  },
  EU_DNK: {
     lat: 56,
     lng: 10
  },
  EU_ESP: {
     lat: 40,
     lng: -4
  },
  EU_EST: {
     lat: 59,
     lng: 26
  },
  EU_FIN: {
     lat: 64,
     lng: 26
  },
  EU_FRA: {
     lat: 46,
     lng: 2
  },
  EU_GBR: {
     lat: 54,
     lng: -2
  },
  EU_GRC: {
     lat: 39,
     lng: 22
  },
  EU_HRV: {
     lat: 45.1667,
     lng: 15.5
  },
  EU_HUN: {
     lat: 47,
     lng: 20
  },
  EU_IRL: {
     lat: 53,
     lng: -8
  },
  EU_ITA: {
     lat: 42.8333,
     lng: 12.8333
  },
  EU_ISL: {
     lat: 65,
     lng: -18
  },
  EU_KOS: {
     lng: 20.76216,
     lat: 42.05186
  },
  EU_LTU: {
     lat: 56,
     lng: 24
  },
  EU_LVA: {
     lat: 57,
     lng: 25
  },
  EU_LUX: {
     lat: 49.75,
     lng: 6.1667
  },
  EU_MDA: {
     lat: 47,
     lng: 29
  },
  EU_MKD: {
     lat: 41.8333,
     lng: 22
  },
  EU_MNE: {
     lat: 42,
     lng: 19
  },
  EU_NLD: {
     lat: 52.5,
     lng: 5.75
  },
  EU_NOR: {
     lat: 62,
     lng: 10
  },
  EU_POL: {
     lat: 52,
     lng: 20
  },
  EU_PRT: {
     lat: 39.5,
     lng: -8
  },
  EU_ROU: {
     lat: 46,
     lng: 25
  },
  EU_RUS: {
     lat: 60,
     lng: 100
  },
  EU_SRB: {
     lat: 44,
     lng: 21
  },
  EU_SVK: {
     lat: 48.6667,
     lng: 19.5
  },
  EU_SVN: {
     lat: 46,
     lng: 15
  },
  EU_SWE: {
     lat: 62,
     lng: 15
  },
  EU_UKR: {
     lat: 49,
     lng: 32
  }
}

export default countriesCoordsDict